import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ResponseService } from '../../models/response-service.model';

@Injectable({
    providedIn: 'root'
})
export class ChatbotService {

    constructor(private http: HttpClient) { }

  //amount of lead
  public sendMessage(leads_info: any, messages: any){
    leads_info = JSON.stringify(leads_info);
    messages = JSON.stringify(messages);
    const url = `${environment.api}chat_bot/send_message`;
    var formData: any = new FormData();
    formData.append('leads_info', leads_info);
    formData.append('messages', messages);
    // return this.http.get<ResponseService>(url);
    return this.http.post<ResponseService>(url, formData);
  }

  public get_user_leads(userId: number, dateStart:string, dateEnd:string){

    if (dateStart==""){
      dateStart = "-";
    }
    if (dateEnd==""){
      dateEnd = "-";
    }

    const url = `${environment.api}chat_bot/${userId}/${dateStart}/${dateEnd}/get_user_leads`;
    return this.http.get(url);
  }
}
